exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.analysis-panel {\n        background-color: white;\nposition: fixed;\ntop: 100px;\nleft: 100px;\nwidth: calc(100vw - 200px);\nheight: calc(100vh - 200px);\ndisplay: block;\nz-index: 999;\nmargin-top: 100px;\noverflow: auto;\npadding: 2rem;\ntext-align: left;\n}\n", ""]);

// exports
